import React, { useState, useEffect } from "react";
import InputWrapper from "../../general/InputWrapper";
import classes from "./DateInput.module.css";

const DateInput = ({
  title,
  desc_text,
  extra_text,
  help_text,
  inputObject,
  fieldName,
  inputs,
  updateInput,
  errors,
  msgs
}) => {

  const is_pr = fieldName === "dateOfPartRet"
  const starting_day_val = is_pr ? '01' : ''
  const [day, setDay] = useState(starting_day_val);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const day_val = is_pr ? 1 : day

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ];

  const [monthsLocal, setMonthsLocal] = useState(months)

  useEffect(() => {
    if (inputs.memberInfo[fieldName]) {
      const [initialYear, initialMonth, initialDay] =
        inputs.memberInfo[fieldName].split("-");
      setDay(initialDay);
      setMonth(initialMonth);
      setYear(initialYear);
    }
  }, [inputs, fieldName]);

  const updateDate = (newDay, newMonth, newYear) => {
    //console.log(newMonth)
    //if (newMonth.length === 1) newMonth = "0" + String(newMonth)
    if (newDay && newMonth && newYear) {
      const formattedDate = `${newYear}-${newMonth}-${newDay}`;
      //console.log(formattedDate)
      updateInput(inputObject, fieldName, formattedDate);
    }
  };

  const curr_year = new Date().getFullYear()
  const curr_month_raw = new Date().getMonth() + 1

  //console.log(curr_year)

  var curr_month =  String(curr_month_raw).length === 1 ? "0" + curr_month_raw : curr_month_raw
  //console.log(curr_month_raw, curr_month)

  const handleDayChange = (value) => {
    setDay(value);
    updateDate(value, month, year);
  };

  const handleMonthChange = (value) => {
    setMonth(value.length === 1 ? "0" + String(value) : value);
    updateDate(day, value.length === 1 ? "0" + String(value) : value, year);
  };

  const min_max_mapper = {
    "dateOfPartRet" : {'min' : curr_year, 'max' : curr_year + 5}
  }
  const minYear = min_max_mapper[fieldName] ? min_max_mapper[fieldName].min : 1900;
  const maxYear = min_max_mapper[fieldName] ? min_max_mapper[fieldName].max : curr_year

  const handleYearChange = (value) => {
    if (value.length >= 4) {
      if (value < minYear) {
        value = minYear;
      }

      if (value > maxYear) {
        value = maxYear;
      }
    }

    if (fieldName === 'dateOfPartRet' && parseInt(value) === curr_year) {
      const remainingMonths = months.filter(month => {  
        const monthYear = parseInt(`${curr_year}${month.value}`);  
        const currentMonthYear = parseInt(`${curr_year}${curr_month}`);  
        return monthYear > currentMonthYear;  
      }); 

      setMonthsLocal(remainingMonths)
    } else if ((fieldName === 'dateOfPartRet' && parseInt(value) === maxYear && curr_month !== "01")  || (parseInt(value) === curr_year && curr_month !== "01")) {
      const remainingMonths = months.filter(month => {  
        const monthYear = parseInt(`${curr_year}${month.value}`);  
        const currentMonthYear = parseInt(`${curr_year}${curr_month}`);  
        return monthYear < currentMonthYear;  
      }); 

      setMonthsLocal(remainingMonths)      
    } else {
      setMonthsLocal(months)
    }

    if ((fieldName === 'dateOfPartRet' && parseInt(value) === maxYear && curr_month === "01") || (fieldName !== 'dateOfPartRet' && parseInt(value) === curr_year && curr_month === "01")) {
      value = value - 1
    }

    //if (month.length === 1) {setMonth("0" + String(month))}
    // console.log(month, month.length)
    setYear(value);
    updateDate(day, month.length === 1 ? "0" + String(month) : month, value);
  };

  return (
    <InputWrapper
      title={title}
      desc_text={desc_text}
      extra_text={extra_text}
      help_text={help_text}
      error_text={errors[fieldName]}
      msg_text={msgs[fieldName]}
    >
      <section className={classes.input_container}>
        {!is_pr &&
        <select
          name={`${fieldName}Day`}
          value={day_val}
          onChange={(e) => handleDayChange(e.target.value)}
          disabled = {is_pr}
          required = {!is_pr}
        >
          <option value="" disabled selected hidden>
            Day
          </option>
          {days.map((day) => (
            <option key={day} value={String(day).padStart(2, "0")}>
              {day}
            </option>
          ))}
        </select>
        }
        <select
          name={`${fieldName}Month`}
          value={month}
          onChange={(e) => handleMonthChange(e.target.value)}
          required
        >
          <option value="" disabled selected hidden>
            Month
          </option>
          {monthsLocal.map((month) => (
            <option key={month.value} value={month.value}>
              {month.label}
            </option>
          ))}
        </select>
        <input
          className={classes.number_input}
          type="number"
          name={`${fieldName}Year`}
          value={year}
          placeholder="Year"
          onChange={(e) => handleYearChange(e.target.value)}
          min={minYear}
          max={maxYear}
          required
        />
      </section>
    </InputWrapper>
  );
};

export default DateInput;
